import { Navigate, useLocation } from 'react-router-dom';
import AuthPageLayout from './layouts/AuthPageLayout';
import { useSelector } from 'react-redux';
import NonAuthPageLayout from './layouts/NonAuthPageLayout';
import { useEffect } from 'react';

function ProtectedRoute({ children, isProtected, HeaderComp, bare = false }) {
  const { search, pathname, hash } = useLocation();
  const queryAccessToken = new URLSearchParams(search).get('accessToken');

  useEffect(() => {
    if (!queryAccessToken) return;

    const params = new URLSearchParams(search);
    const queryRefreshToken = params.get('refreshToken');

    localStorage.setItem('accessToken', queryAccessToken);
    if (queryRefreshToken) {
      localStorage.setItem('refreshToken', queryRefreshToken);
    } else {
      // Drop a leftover refresh token so a previous user on this browser is not renewed in
      localStorage.removeItem('refreshToken');
    }

    params.delete('accessToken');
    params.delete('refreshToken');
    const nextSearch = params.toString();
    const nextUrl = `${pathname}${nextSearch ? `?${nextSearch}` : ''}${hash || ''}`;
    window.history.replaceState({}, document.title, nextUrl);
    window.location.reload();
  }, [queryAccessToken, search, pathname, hash]);

  // Check if the user is authenticated by getting the state from Redux
  const isAuth = useSelector(state => state.auth.data.isAuth);

  // If the route is protected and the user is not authenticated, navigate to the login page
  if (isProtected && !isAuth) {
    return <Navigate to="/login" replace />;
  }

  // Full-screen protected pages (the OAuth consent screen) skip the app shell
  if (isProtected && bare) {
    return children;
  }

  // If the route is protected, wrap the children in the AuthPageLayout
  if (isProtected) {
    return <AuthPageLayout HeaderComp={HeaderComp}>{children}</AuthPageLayout>;
  }

  // If the route is not protected, wrap the children in the NonAuthPageLayout
  return <NonAuthPageLayout>{children}</NonAuthPageLayout>;
}

export default ProtectedRoute;
